module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/$.is-object.js
// module id = 5
// module chunks = 0